<!--
   Created by qing on 2020/2/11 7:56 下午
   Des:
-->
<template>
  <div class="ry-form__contacts-view">
    <van-tag
      v-for="(depId, idx) in depart"
      class="ry-contacts__tag"
      v-if="$store.getters.depListMap[depId]"
      :key="'dep' +  depId"
      size="medium">
      <avatar
        style="margin-right: 5px"
        backgroundColor="#2db7f5"
        :username="$store.getters.depListMap[depId].depName"
        :size="20">
      </avatar>
      <span>
          {{$store.getters.depListMap[depId]['depName']}}
      </span>
    </van-tag>

    <van-tag
      v-for="(roleId, idx) in role"
      type="success"
      class="ry-contacts__tag"
      v-if="$store.getters.rolesMap[roleId]"
      :key="'role' + roleId"
      size="medium">
      <avatar
        style="margin-right: 5px"
        backgroundColor="#FFC107"
        :username="$store.getters.rolesMap[roleId].roleName"
        :size="20">
      </avatar>
      <span>
           {{$store.getters.rolesMap[roleId]['roleName']}}
      </span>
    </van-tag>

    <van-tag
      v-for="(userId, idx) in member"
      type="info"
      class="ry-contacts__tag"
      v-if="$store.getters.userListMap[userId]"
      :key="'user' + userId"
      size="medium">
      <van-image
        style="margin-right: 5px"
        round
        width="20px"
        height="20px"
        :src="$store.getters.userListMap[userId]['headImg']">
      </van-image>
      <span>
        {{$store.getters.userListMap[userId]['nickname']}}
      </span>
    </van-tag>

    <van-tag
      v-for="(userId, idx) in member"
      type="info"
      class="ry-contacts__tag"
      v-if="$store.getters.leaveMemberListMap[userId]"
      :key="'user' + userId"
      size="medium">
      <van-image
        style="margin-right: 5px"
        round
        width="20px"
        height="20px"
        :src="$store.getters.leaveMemberListMap[userId]['headImg']">
      </van-image>
      <span>
        {{$store.getters.leaveMemberListMap[userId]['nickname']}}
      </span>
    </van-tag>

    <van-tag
      v-for="(userId, idx) in external"
      type="info"
      class="ry-contacts__tag"
      v-if="$store.getters.extMap[userId]"
      :key="'user' + userId"
      size="medium">
      <van-image
        style="margin-right: 5px"
        round
        width="20px"
        height="20px"
        :src="$store.getters.extMap[userId]['headImg']">
      </van-image>
      <span>
        {{$store.getters.extMap[userId]['orgUserName'] || $store.getters.extMap[userId]['nickname']}}
      </span>
    </van-tag>

    <van-tag
      v-for="(userId, idx) in external"
      type="info"
      class="ry-contacts__tag"
      v-if="$store.getters.leaveExternalMap[userId]"
      :key="'user' + userId"
      size="medium">
      <van-image
        style="margin-right: 5px"
        round
        width="20px"
        height="20px"
        :src="$store.getters.leaveExternalMap[userId]['headImg']">
      </van-image>
      <span>
        {{$store.getters.leaveExternalMap[userId]['orgUserName'] || $store.getters.extMap[userId]['nickname']}}
      </span>
    </van-tag>

    <van-tag
      v-for="(labelId, idx) in externalTag"
      type="info"
      class="ry-contacts__tag"
      v-if="$store.getters.extLabelMap[labelId]"
      :key="'user' + labelId"
      size="medium">
      <span>
        {{$store.getters.extLabelMap[labelId]['labelName']}}
      </span>
    </van-tag>

    <van-tag
      v-for="(dyn, idx) in dynamic"
      type="warning"
      class="ry-contacts__tag"
      :key="'dyn' + dyn.fieldId"
      size="medium">
      <van-image
        style="margin-right: 5px"
        round
        width="20px"
        height="20px"
        src="">
      </van-image>
      <span>
        {{dyn.fieldTitle}}
      </span>
    </van-tag>
  </div>
</template>

<script>
  import Avatar from 'vue-avatar'
  export default {
    components: {
      Avatar
    },
    props: {
      depart: {
        type: Array,
        default: () => []
      },
      role: {
        type: Array,
        default: () => []
      },
      member: {
        type: Array,
        default: () => []
      },
      external: {
        type: Array,
        default: () => []
      },
      externalTag: {
        type: Array,
        default: () => []
      },
      dynamic: {
        type: Array,
        default: () => []
      },
    }
  }
</script>

<style lang="less">
  .ry-form__contacts-view {
    font-size: 0;
    line-height: 0;
    min-height: 40px;

    .van-tag {
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      color: #909399;
      font-size: 12px;
      margin-left: 10px;
      margin-bottom: 5px;
    }

  }
</style>